// rem 等比适配配置文件
// 需要依赖 postcss-pxtorem  并在config进行配置
// 基准大小
const baseSize = 14
// 设置 rem 函数
function setRem(){
  // 当前页面宽度相对于 1920 宽的等比缩放
  const scale = document.documentElement.clientWidth / 1920
  // 设置页面根节点大小
  document.documentElement.style.fontSize = baseSize * scale + 'px'
  console.log('resize');
}

// 初始化
setRem()

window.addEventListener('resize', () => {
  setRem()
})
